export function getNestedObj(parentObj, keyPath) {
  return keyPath.reduce((obj, path) => {
    if (Array.isArray(obj))
      return obj.map((item) => getPropertyOrUndefined(item, path));
    return getPropertyOrUndefined(obj, path);
  }, parentObj);
}

export function setNestedObj(parentObj, keyPath, value) {
  const newObj = { ...parentObj };
  const key = keyPath.pop();
  const pointer = keyPath.reduce((accumulator, currentValue) => {
    if (accumulator[currentValue] === undefined) accumulator[currentValue] = {};
    return accumulator[currentValue];
  }, newObj);
  pointer[key] = value;
  keyPath.push(key);
  return newObj;
}

const getPropertyOrUndefined = (obj, path) =>
  obj && typeof obj[path] !== 'undefined' ? obj[path] : undefined;



// WEBPACK FOOTER //
// ./src/helpers/getNestedObject.js